import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

import Title from 'src/refactor_components/common/Title';

import {
  MdDirectionsCar,
  MdOutlineShower,
  MdScreenLockLandscape
} from 'react-icons/md';
import { GiTowel } from 'react-icons/gi';
import { PiCoatHanger } from 'react-icons/pi';
import { TbShirtFilled } from 'react-icons/tb';

const CheckableButton = ({
  registerName,
  label,
  children
}: {
  registerName: string;
  label?: string;
  children?: ReactNode;
}) => {
  const methods = useFormContext();
  return (
    <div>
      <input
        {...methods.register(registerName)}
        id={label}
        type="checkbox"
        className="peer hidden"
      />
      <label
        htmlFor={label}
        className="peer-checked:text-[#7750E9] flex items-center justify-between text-[#C9C7D1] py-8 px-16 rounded-full border-1 bg-[#1F1E25] border-solid border-[#2E2B36] peer-checked:border-[#7750E9]"
      >
        {children}
        {label}
      </label>
    </div>
  );
};

const GymAddAmenities = () => {
  return (
    <div className="flex flex-col gap-8 items-start">
      <Title text="편의 시설" />
      <div className="flex gap-8 flex-wrap ">
        {AMENITIES_ITEMS.map(({ registerName, label, icons }) => {
          return (
            <CheckableButton
              key={label}
              registerName={registerName}
              label={label}
            >
              {icons}
            </CheckableButton>
          );
        })}
      </div>
    </div>
  );
};

const AMENITIES_ITEMS = [
  {
    registerName: 'showerRoom',
    label: '샤워실',
    icons: <MdOutlineShower style={{ marginRight: 5, width: 17, height: 18 }} />
  },
  {
    registerName: 'fittingRoom',
    label: '탈의실',
    icons: <PiCoatHanger style={{ marginRight: 5, width: 16, height: 18 }} />
  },
  {
    registerName: 'sportswear',
    label: '운동복',
    icons: <TbShirtFilled style={{ marginRight: 5, width: 16, height: 18 }} />
  },
  {
    registerName: 'locker',
    label: '사물함',
    icons: (
      <MdScreenLockLandscape
        style={{ marginRight: 5, width: 16, height: 18 }}
      />
    )
  },
  {
    registerName: 'tower',
    label: '수건',
    icons: <GiTowel style={{ marginRight: 5, width: 16, height: 18 }} />
  },
  {
    registerName: 'parkingSpace',
    label: '주차가능',
    icons: <MdDirectionsCar style={{ marginRight: 5, width: 16, height: 18 }} />
  }
];

export default GymAddAmenities;
